import axios from "axios";

const BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://express-server-gules-mu.vercel.app";

// Funzione per recuperare tutte le categorie
export async function fetchAllCategories() {
    try {
        const response = await axios.get(`${BASE_URL}/categories`);
        return response.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        return [];
    }
}

// Funzione per recuperare una categoria per ID
export async function fetchCategoryById(categoryId) {
    try {
        const response = await axios.get(`${BASE_URL}/categories/${categoryId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching category with ID ${categoryId}:`, error);
        return null;
    }
}

// Funzione per creare una nuova categoria
export async function createCategory(newCategoryData) {
    try {
        const response = await axios.post(`${BASE_URL}/categories`, newCategoryData);
        return response.data;
    } catch (error) {
        console.error('Error creating new category:', error);
        return null;
    }
}

// Funzione per aggiornare una categoria
export async function updateCategory(categoryId, updatedCategoryData) {
    try {
        const response = await axios.put(`${BASE_URL}/categories/${categoryId}`, updatedCategoryData);
        return response.data;
    } catch (error) {
        console.error(`Error updating category with ID ${categoryId}:`, error);
        return null;
    }
}

// Funzione per eliminare una categoria
export async function deleteCategory(categoryId) {
    try {
        const response = await axios.delete(`${BASE_URL}/categories/${categoryId}`);
        return response.status === 200;
    } catch (error) {
        console.error(`Error deleting category with ID ${categoryId}:`, error);
        return false;
    }
}
